import React from 'react'
import { NavLink } from 'react-router-dom';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from 'react-i18next';
import useEscapeKeyDown from "../hooks/useEscapeKeyDown";


const ModalForGuest = ({ closeModalData }) => {
  const { t } = useTranslation();
  useEscapeKeyDown(true, closeModalData);
  return (
    <>
      <div
        className="modal modal-md fade show postAdd"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog " role="document">
          <div className="modal-content d-flex justify-content-around">
            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
              <h6 className='mb-0'> {t("SignIn.To act on Welinkjobs")}</h6>
              {/* <span
                className="material-symbols-sharp me-2 pointer"
                onClick={closeModalData}
              >
                close
              </span> */}
              <CloseSharpIcon className="material-symbols-sharp me-2 pointer"
                  onClick={closeModalData}
                  />
            </div>

            <div
              className="card-body d-flex flex-wrap justify-content-center p-3 f-14"
              id="container"  >
              <div style={{textAlign: "left"}}>
                <p>{t("SignIn.You are exploring as guest mode.!!!")}</p>
                <p className='mb-3'> {t("SignIn.Once you join Welinkjobs, you can do more.")}</p>
                <a>{t("SignIn.To Stay connected for Jobs & More,")}<NavLink to="/SignUp" className='fw-bold'> {t("SignIn.Create an account")} </NavLink> {t("SignIn.or")} <div className="mt-3">
                  <NavLink to="/SignIn">
                    <button type="button" className="mainBtn">
                     {t("SignIn.Sign in")} 
                    </button>
                  </NavLink>

                </div></a>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ModalForGuest